/**
 * This is a proxy of "@pcmp-checka/lib-services-common/utils/item-status-machine".
 * Must find a better way so the module is compatible between base interface of
 * "ItemStatus" and the one after generating the API code.
 */
import { ItemStatus as IItemStatus } from '@pcmp-checka/lib-services-common/domain/models/db-order';
import { ItemStatus as ApiItemStatus } from '@/redux/back-dashboard-api';
import { Role } from '@pcmp-checka/lib-utilities/atkomst';

import {
  ITEM_STATUS_MACHINE as API_ITEMS_STATUS_MACHINE,
  TransitionContext,
} from '@pcmp-checka/lib-services-common/utils/item-status-machine';

const isItemStatus = (value: string): value is ApiItemStatus =>
  Object.keys(ApiItemStatus).includes(value);

const getApiItemStatus = (status: IItemStatus): ApiItemStatus => {
  const [key] =
    Object.entries(IItemStatus).find(([_, v]) => v === status) || [];

  if (!key || !isItemStatus(key))
    throw new Error(`Invalid ItemStatus: ${status}`);

  return ApiItemStatus[key];
};

// item status state machine
export const ITEM_STATUS_MACHINE = Object.keys(API_ITEMS_STATUS_MACHINE).reduce(
  (acc, key) => {
    const entry = API_ITEMS_STATUS_MACHINE[key as IItemStatus];
    acc[getApiItemStatus(entry.status)] = {
      ...entry,
      status: getApiItemStatus(entry.status),
      evaluate: (context: TransitionContext) => {
        return entry.evaluate(context).map(getApiItemStatus);
      },
      reasons: entry.reasons,
    };

    return acc;
  },
  {} as Record<
    ApiItemStatus,
    {
      status: ApiItemStatus;
      evaluate: (context: TransitionContext) => ApiItemStatus[]; // Evaluate next states based on context
      updateRole: Role[]; // The roles required (one of) to update to this status
      updateByManager: boolean; // The status can be updated by the user manager, even though not in updateRole
      reasons: string[]; // The possible reasons for this status
    }
  >
);

export const getItemStatus = (status: ApiItemStatus) =>
  ITEM_STATUS_MACHINE[status];

export const getNextItemStatuses = (
  status: ApiItemStatus,
  context: TransitionContext = {}
) => getItemStatus(status).evaluate(context);
